import { ReleaseCard } from "./ReleaseCard";

export default ReleaseCard;
